module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.id) ? _c('div', {
    staticClass: "btn-group w5-opers-button",
    class: {
      'w5-opers-button-opened': _vm.show, 'pull-left-ticket-message-opers-button': _vm.toLeft, 'pull-right': !_vm.toLeft
    },
    staticStyle: {
      "top": "-2px"
    },
    attrs: {
      "data-index": _vm.id
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleMenu($event)
      }
    }
  }, [_c('span', {
    staticClass: "dropdown-toggle"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "bars"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "caret"
  })], 1), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "dropdown-menu",
    style: (_vm.cssUl),
    attrs: {
      "role": "menu"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [(_vm.isUpdateButtonVisible) ? _c('li', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.clickOper('update')
      }
    }
  }, [_c('font-awesome-layers', {
    staticClass: "w5-dropdown-menu-item w5-opers-button-other-btn"
  }, [_c('font-awesome-icon', {
    staticClass: "color-green",
    attrs: {
      "icon": "pencil-alt"
    }
  }), _vm._v("\n\t\t\t\t" + _vm._s(_vm._f("ftc")('main/redact')) + "\n\t\t\t")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isUpdateButtonVisible && (_vm.isQuoteButtonVisible || _vm.isViewButtonVisible || _vm.isDeleteButtonVisible)) ? _c('li', {
    staticClass: "divider"
  }) : _vm._e(), _vm._v(" "), (_vm.isQuoteButtonVisible) ? _c('li', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.clickOper('quote')
      }
    }
  }, [_c('font-awesome-layers', {
    staticClass: "w5-dropdown-menu-item w5-opers-button-other-btn"
  }, [_c('font-awesome-icon', {
    staticStyle: {
      "color": "#2c8ad8"
    },
    attrs: {
      "icon": "quote-right"
    }
  }), _vm._v("\n\t\t\t\t" + _vm._s(_vm._f("ftc")('main/quote')) + "\n\t\t\t")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isViewButtonVisible) ? _c('li', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.clickOper('view')
      }
    }
  }, [_c('font-awesome-layers', {
    staticClass: "w5-dropdown-menu-item w5-opers-button-other-btn"
  }, [_c('font-awesome-icon', {
    staticStyle: {
      "color": "#2c8ad8"
    },
    attrs: {
      "icon": "eye"
    }
  }), _vm._v("\n\t\t\t\t" + _vm._s(_vm._f("ftc")('main/view')) + "\n\t\t\t")], 1)], 1) : _vm._e(), _vm._v(" "), ((_vm.isUpdateButtonVisible || _vm.isQuoteButtonVisible || _vm.isViewButtonVisible) && _vm.isDeleteButtonVisible) ? _c('li', {
    staticClass: "divider"
  }) : _vm._e(), _vm._v(" "), (_vm.isDeleteButtonVisible) ? _c('li', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.clickOper('delete')
      }
    }
  }, [_c('font-awesome-layers', {
    staticClass: "w5-dropdown-menu-item w5-opers-button-other-btn"
  }, [_c('font-awesome-icon', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "icon": "trash-alt"
    }
  }), _vm._v("\n\t\t\t\t" + _vm._s(_vm._f("ftc")('ticketrule/action_delete')) + "\n\t\t\t")], 1)], 1) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a7a194f"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/ticketmsgopers.vue
// module id = 697
// module chunks = 0